define( [
	"../Data"
], function( Data ) {
	return new Data();
} );



//////////////////
// WEBPACK FOOTER
// /~/jquery/src/data/var/dataPriv.js
// module id = 189
// module chunks = 0